import {CONFIG} from "../../config";
import axios from "axios";

async function GetVehiclesQuery(device_id, from_date, to_date, signal) {
    const location = CONFIG.API_URL + "statistics/vehicles/" + device_id + "/" + from_date + "/" + to_date;
    const settings = {

        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        },
        signal: signal
    };

    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetVehiclesQuery;